export default __webpack_public_path__ + "static/media/Underdog_Black_Font.23d620c5.png";